module.exports = __webpack_public_path__ + "img/Lua.dad31eaf.png";